var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModaleGauche',{attrs:{"id":"annoter","title":_vm.$t('annoter_titre')}},[_c('DrawingModes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }